function resolveApiBaseUrl() {
  const configuredBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL?.trim();
  if (configuredBaseUrl) {
    return configuredBaseUrl;
  }
  throw new Error("NEXT_PUBLIC_API_BASE_URL is not configured for this environment.");
}

export function getApiBaseUrl() {
  return resolveApiBaseUrl();
}

export async function apiFetch(path: string, options: RequestInit = {}) {
  const baseUrl = getApiBaseUrl();
  const requestUrl = `${baseUrl}${path}`;
  if (typeof window !== "undefined") {
    console.log("[apiFetch]", {
      baseUrl,
      path,
      method: options.method || "GET",
      requestUrl,
    });
  }
  const res = await fetch(requestUrl, {
    ...options,
    headers: {
      ...(options.headers || {}),
    },
  });
  if (res.status === 401 || res.status === 403) {
    if (typeof window !== "undefined") {
      localStorage.removeItem("access_token");
      if (window.location.pathname.startsWith("/admin")) {
        window.location.href = "/admin/login";
      }
    }
  }
  if (!res.ok) {
    const text = await res.text();
    let message = text || "Request failed";

    if (text) {
      try {
        const parsed = JSON.parse(text) as { detail?: string; message?: string | string[] };
        message =
          parsed.detail ||
          (Array.isArray(parsed.message) ? parsed.message.join(", ") : parsed.message) ||
          message;
      } catch {
        message = text;
      }
    }

    throw new Error(message);
  }
  return res;
}

export async function uploadFileWithProgress({
  path,
  file,
  sessionId,
  extraFields,
  useBaseUrl = true,
  onProgress,
}: {
  path: string;
  file: File;
  sessionId?: string;
  extraFields?: Record<string, string>;
  useBaseUrl?: boolean;
  onProgress?: (progress: number) => void;
}): Promise<any> {
  const baseUrl = getApiBaseUrl();
  const form = new FormData();
  form.append("file", file);
  if (sessionId) {
    form.append("session_id", sessionId);
  }
  if (extraFields) {
    for (const [key, value] of Object.entries(extraFields)) {
      form.append(key, value);
    }
  }

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const requestUrl = useBaseUrl ? `${baseUrl}${path}` : path;
    xhr.open("POST", requestUrl);

    xhr.upload.onprogress = (event) => {
      if (!event.lengthComputable) return;
      const progress = Math.min(100, Math.round((event.loaded / event.total) * 100));
      onProgress?.(progress);
    };

    xhr.onload = () => {
      const text = xhr.responseText || "";

      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          resolve(text ? JSON.parse(text) : null);
        } catch {
          resolve(null);
        }
        return;
      }

      let message = text || "Request failed";
      if (text) {
        try {
          const parsed = JSON.parse(text) as { detail?: string; message?: string | string[] };
          message =
            parsed.detail ||
            (Array.isArray(parsed.message) ? parsed.message.join(", ") : parsed.message) ||
            message;
        } catch {}
      }

      reject(new Error(message));
    };

    xhr.onerror = () => reject(new Error("Network error while uploading file"));
    xhr.send(form);
  });
}
